
import { defineComponent, computed, ref } from 'vue'
export default defineComponent({
  name: 'UncheckRiskModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => null as any
    }
  },
  emits: ['closeVirusScanModal'],
  setup (props, context) {
    const copyCntrTxt = ref(null)
    const modalVisiable = computed(() => props.show)
    const innerContent = computed(() => props.content ? JSON.parse(props.content.virus_info || '{}') : null)
    const payload = computed(() => innerContent.value ? JSON.parse(innerContent.value.payload || '{}') : {})
    return {
      modalVisiable,
      innerContent,
      payload,
      copyCntrTxt,
      closeModal () {
        context.emit('closeVirusScanModal', 'UNCHECK_RISK_MODAL')
      },
      copyTxt () {
        const selection = document.getSelection()
        selection.selectAllChildren(copyCntrTxt.value)
        document.execCommand('copy')
      }
    }
  }
})
